/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCirclePlus2 = createReactComponent("circle-plus-2", "IconCirclePlus2", [
  ["path", { d: "M20.985 12.522a9 9 0 1 0 -8.475 8.464", key: "svg-0" }],
  ["path", { d: "M16 19h6", key: "svg-1" }],
  ["path", { d: "M19 16v6", key: "svg-2" }]
]);

export { IconCirclePlus2 as default };
//# sourceMappingURL=IconCirclePlus2.js.map
